export default {
  namespaced: true,
  
  state: () => {
    return {
      show: function(data){
        console.log(data);
      }
    }
  },
  
  mutations: {
    listen(state, data){
      state.show = data;
    }
  },

  actions: {
    show({state}, data){
      state.show(data);
    }
  }
};
